import {Injectable} from '@angular/core';
import {countryConfig} from 'src/country-config/country-config';
import { PATTERNS } from '../constants/pattern';

@Injectable({
  providedIn: 'root',
})
export class FormErrorValidatorService {
  defaultOptions = {
    minPassword: 6,
    maxPassword: 40,
    phoneLength: countryConfig.phoneLength,
  };
  required = 'Campo requerido.';

  textValidator(prop, values, form, error) {
    const messageError = error;
    if (!values[prop] && values[prop] === '') {
      if (form.get(prop).dirty || form.get(prop).touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    } else {
      messageError[prop] = '';
      return messageError;
    }
    return messageError;
  }

  onlyText(prop, values, form, error) {
    const messageError = error;
    const pattern = new RegExp(PATTERNS.ALPHANUMERIC_WITH_SPACES);

    if (!values[prop] || values[prop] === '') {
      if (form.get(prop)?.dirty || form.get(prop)?.touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    } else if (!pattern.test(values[prop])) {
      if (form.get(prop).dirty || form.get(prop).touched) {
        messageError[prop] = 'No se permiten caracteres especiales.';
        return messageError;
      }
    } else {
      messageError[prop] = '';
      return messageError;
    }
  
    return messageError;
  }

  emailValidator(prop, values, form, error) {
    const messageError = error;
    const valid = parseInt(values[prop], 10);
    if (!Number.isNaN(valid)) {
      if (values[prop]) {
        messageError[prop] = '';
        if (form.get(prop).errors && form.get(prop).errors.maxlength) {
          messageError[prop] = `El número de teléfono debe tener ${this.defaultOptions.phoneLength} caracteres.`;
          return messageError;
        }
      } else if (!values[prop] && values[prop] === '') {
        if (form.get(prop).dirty || form.get(prop).touched) {
          messageError[prop] = this.required;
          return messageError;
        }
      }
    } else {
      messageError[prop] = '';
      if (values[prop]) {
        if (form.get(prop).errors && form.get(prop).errors.invalidFormat) {
          messageError[prop] = 'Formato de correo inválido';
          return messageError;
        }
      } else if (!values[prop] && values[prop] === '') {
        if (form.get(prop).dirty || form.get(prop).touched) {
          messageError[prop] = this.required;
          return messageError;
        }
      }
    }
    return messageError;
  }

  phoneValidator(prop, values, form, error, options, secondary = false) {
    const messageError = error;
    if (values[prop]) {
      messageError[prop] = '';
      if (form.get(prop).errors) {
        if (form.get(prop).errors.notExactLength) {
          messageError[
            prop
          ] = `El número de teléfono debe tener ${options.phoneLength} caracteres.`;
          return messageError;
        }
        if (form.get(prop).errors.startsWithZero && countryConfig.signUpForm.zeroValidator) {
          messageError[prop] = 'El número de teléfono no puede comenzar con cero.';
          return messageError;
        }
        if (form.get(prop).errors.notNumbers) {
          messageError[prop] = 'Solo se permiten caracteres numéricos.';
          return messageError;
        }
      }
    } else if (!secondary && !values[prop] && values[prop] === '') {
      if (form.get(prop).dirty || form.get(prop).touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  documentNumberValidator(prop, values, form, error) {
    const messageError = error;
    if (values[prop]) {
      messageError[prop] = '';
      if (form.get(prop).errors) {
        if (form.get(prop).errors.notNumbers) {
          messageError[prop] = 'Solo se permiten caracteres numéricos.';
          return messageError;
        }
        if (form.get(prop).errors.startsWithZero && countryConfig.allowIdStartsWithZero) {
          messageError[prop] = 'El número de documento no puede comenzar con cero.';
          return messageError;
        }
      }
    } else if (!values[prop] && values[prop] === '') {
      if (form.get(prop).dirty || form.get(prop).touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  passwordValidator(prop, value, formControl, error, options) {
    const messageError = error;
    if (value) {
      messageError[prop] = '';
      if (!formControl.valid) {
        messageError[
          prop
        ] = `Contraseña de ${options.minPassword} a ${options.maxPassword} caracteres`;
        return messageError;
      }else{
        Object.values(formControl.value).forEach(l => {
          if(l === ' '){
            messageError[prop] = 'Formato inválido'
          }
        });
        return messageError;
      }
    } else if (!value && value === '') {
      if (formControl.dirty || formControl.touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  passwordMatchValidator(confirmProp, confirmValue, formGroup, error) {
    const messageError = error;
    messageError[confirmProp] = '';
    if (confirmValue) {
      if (formGroup.errors) {
        if (formGroup.errors.dontMatch) {
          messageError[confirmProp] = 'Las contraseñas no coinciden';
          return messageError;
        }
      }
    }
    return messageError;
  }

  locationValidator(prop, values, form, error) {
    const messageError = error;
    if (!values[prop] && values[prop] === '') {
      messageError[prop] = this.required;
      return messageError;
    }
    messageError[prop] = '';
    return messageError;
  }

  creditCardNumberValidator(prop, values, form, error) {
    const messageError = error;
    if (values[prop]) {
      messageError[prop] = '';
      if (form.get(prop).errors) {
        if (form.get(prop).errors.notNumbers) {
          messageError[prop] = 'Solo se permiten caracteres numéricos.';
          return messageError;
        }
        if (form.get(prop).errors.startsWithZero) {
          messageError[prop] = 'La tarjeta de crédito no puede comenzar con cero.';
          return messageError;
        }
        if (form.get(prop).errors.invalidCreditCardNumber) {
          messageError[prop] = 'Debe ser número de tarjeta de crédito válido.';
          return messageError;
        }
      }
    } else if (!values[prop] && values[prop] === '') {
      if (form.get(prop).dirty || form.get(prop).touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  creditCardExpirationDateValidator(confirmProp, confirmValue, formGroup, error) {
    const messageError = error;
    messageError[confirmProp] = '';
    if (confirmValue) {
      if (formGroup.errors) {
        if (formGroup.errors.invalidExpirationDate) {
          messageError[confirmProp] = 'Fecha de expiración inválida.';
          return messageError;
        }
      }
    }
    return messageError;
  }

  creditCardYearValidator(prop, value, formControl, error) {
    const messageError = error;
    if (value) {
      messageError[prop] = '';
      if (formControl.errors) {
        if (formControl.errors.notNumbers) {
          messageError[prop] = 'Solo se permiten caracteres numéricos.';
          return messageError;
        }
        if (formControl.errors.startsWithZero) {
          messageError[prop] = 'El año no puede comenzar con cero.';
          return messageError;
        }
        if (formControl.errors.invalidYear) {
          messageError[prop] = 'Año inválido. No puede exceder los 4 años a partir del presente año.';
          return messageError;
        }
        if (formControl.errors.notExactLength) {
          messageError[prop] = 'El año debe tener 4 caracteres.';
          return messageError;
        }
      }
    } else if (!value && value === '') {
      if (formControl.dirty || formControl.touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  creditCardMonthValidator(prop, value, formControl, error) {
    const messageError = error;
    if (value) {
      messageError[prop] = '';
      if (formControl.errors) {
        if (formControl.errors.notNumbers) {
          messageError[prop] = 'Solo se permiten caracteres numéricos.';
          return messageError;
        }
        if (formControl.errors.invalidMonth) {
          messageError[prop] = 'Debe ser un mes válido.';
          return messageError;
        }
        if (formControl.errors.notExactLength) {
          messageError[prop] = 'El año debe tener 2 caracteres.';
          return messageError;
        }
      }
    } else if (!value && value === '') {
      if (formControl.dirty || formControl.touched) {
        messageError[prop] = this.required;
        return messageError;
      }
    }
    return messageError;
  }

  passwordFormatValidator(prop, value, formControl, error) {
    const messageError = error;
    if (formControl.dirty || formControl.touched) {
      messageError[prop] = '';
      if (value) {
        if (formControl.errors) {
          if (formControl.errors.invalidFormat) {
            messageError[prop] = 'Utiliza como mínimo 6 caracteres, combinando letras (Al menos una mayúscula y una minúscula) y números.';
            return messageError;
          }
        }
      }
    } else {
      messageError[prop] = '';
      return messageError;
    }
    return messageError;
  }

  signUpFormErrorValidator(values, form, error, options?) {
    let varOptions = options;
    varOptions = options || this.defaultOptions;
    this.textValidator('firstName', values, form, error);
    this.textValidator('lastName', values, form, error);
    this.onlyText('firstName', values, form, error);
    this.onlyText('lastName', values, form, error);
    this.documentNumberValidator('documentNumber', values, form, error);
    this.phoneValidator('phone', values, form, error, varOptions);
    this.emailValidator('email', values, form, error);
    this.passwordMatchValidator(
      'confirmPassword',
      values.passwords.confirmPassword,
      form.get('passwords'),
      error,
    );
    this.passwordFormatValidator(
      'password',
      values.passwords,
      form.get('passwords').get('password'),
      error,
    );
  }

  loginFormErrorValidator(values, form, error, options?) {
    let varOptions = options;
    varOptions = options || this.defaultOptions;
    this.emailValidator('email', values, form, error);
    this.passwordValidator('password', values.password, form.get('password'), error, varOptions);
  }

  resetPasswordFormErrorValidator(values, form, error) {
    this.emailValidator('email', values, form, error);
  }

  addressFormValidator(values, form, error) {
    this.textValidator('nickname', values, form, error);
    this.textValidator('address', values, form, error);
    this.textValidator('comments', values, form, error);
    this.locationValidator('city', values, form, error);
  }

  addressFormValidatorAll(values, form, error) {
    this.textValidator('nickname', values, form, error);
    this.textValidator('address', values, form, error);
    this.locationValidator('city', values, form, error);
    this.textValidator('details', values, form, error);
    this.textValidator('comments', values, form, error);
  }

  profileFormValidator(values, form, error, options?) {
    this.textValidator('firstname', values, form, error);
    this.onlyText('firstName', values, form, error);
    this.textValidator('lastName', values, form, error);
    this.onlyText('lastName', values, form, error);
    this.phoneValidator('phone', values, form, error, options);
    this.emailValidator('email', values, form, error);
  }

  creditCardFormValidator(values, form, error) {
    this.documentNumberValidator('customerDocumentNumber', values, form, error);
    this.textValidator('customerName', values, form, error);
    this.creditCardNumberValidator('number', values, form, error);
    this.creditCardExpirationDateValidator(
      'expirationDate',
      values.expirationDate,
      form.get('expirationDate'),
      error,
    );
    this.creditCardMonthValidator(
      'month',
      values.expirationDate.month,
      form.get('expirationDate').get('month'),
      error,
    );
    this.creditCardYearValidator(
      'year',
      values.expirationDate.year,
      form.get('expirationDate').get('year'),
      error,
    );
  }

  changePasswordFormErrorValidator(values, form, error) {
    this.passwordMatchValidator(
      'confirmPassword',
      values.passwords.confirmPassword,
      form.get('passwords'),
      error,
    );
    this.passwordFormatValidator(
      'password',
      values.passwords,
      form.get('passwords').get('password'),
      error,
    );
  }

  callCenterFormErrorValidator(values, form, error, options) {
    this.documentNumberValidator('documentNumber', values, form, error);
    this.phoneValidator('phone', values, form, error, options);
    this.textValidator('firstName', values, form, error);
    this.textValidator('lastName', values, form, error);
    this.emailValidator('email', values, form, error);
    this.textValidator('nickname', values, form, error);
    this.textValidator('deliveryAddress', values, form, error);
    this.locationValidator('city', values, form, error);
    this.phoneValidator('secondaryPhone', values, form, error, options, true);
    this.phoneValidator('localPhone', values, form, error, options, true);
  }
}
